export enum CreferenceEntityType {
  Collab = "collab",
  File = "file",
  Member = "member",
  Product = "product",
  Unknown = "unknown",
  User = "user",
  Version = "version",
}

export const CREFERENCE_ENTITY_TYPE = {
  COLLAB: CreferenceEntityType.Collab,
  FILE: CreferenceEntityType.File,
  MEMBER: CreferenceEntityType.Member,
  PRODUCT: CreferenceEntityType.Product,
  UNKNOWN: CreferenceEntityType.Unknown,
  USER: CreferenceEntityType.User,
  VERSION: CreferenceEntityType.Version,
} satisfies Record<string, CreferenceEntityType>;
